var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-card',{staticClass:"rounded-lg mx-auto pa-0",attrs:{"elevation":"4"}},[_c('v-img',{attrs:{"lazy-src":_vm.$ImageAssets('default', 'reseller_portal1024x1024'),"src":_vm.$ImageAssets('default', 'reseller_portal1024x1024'),"contain":"","height":"85vh"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }